import type {Middleware} from '@linx-security/api-specs';
import type {Logger} from 'pino';
import pino from 'pino';

export const baseLogger = pino({
  level: process.env.LOG_LEVEL || `info`,
  messageKey: `message`,
  serializers: {err: pino.stdSerializers.err, error: pino.stdSerializers.err},
  formatters: {
    level: label => ({level: label}),
  },
});

// TODO: add "pino-http"
export const getLogMiddleware = (base: Logger = baseLogger) => {
  const logger = base.child({scope: `fetch-middleware`}, {});

  return {
    pre: async context => {
      logger.debug(`API Request ${context.url}`, context.init);

      return context;
    },
    post: async context => {
      const {response} = context;
      logger.debug({status: response.status}, `API Response ${context.url}`);
      return context.response;
    },
  } satisfies Middleware;
};
